/**
 * OrderPaymentService
 * Service for OrderPayment entity operations
 * Route: api/orderpayments
 * Controller: OrderPaymentsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * OrderPaymentService
 * Handles order payment CRUD operations.
 * Backend now returns OrderPaymentModelView (enriched) instead of raw entities.
 * Maps to /api/orderpayments endpoint
 */
export class OrderPaymentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderPaymentService.DEFAULT_SERVICE_PATH,
            basePath: OrderPaymentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== QUERY BY ORDER ====================
    /**
     * Get order payments by order ID
     * GET /api/orderpayments?orderId={orderId}
     */
    async getByOrderId(orderId) {
        const response = await this.getByOrderIdRaw(orderId);
        return response.data ?? [];
    }
    /**
     * Get order payments by order ID (raw)
     */
    getByOrderIdRaw(orderId) {
        const url = this.buildUrl(`?orderId=${orderId}`);
        return this.http.get(url);
    }
}
OrderPaymentService.DEFAULT_SERVICE_PATH = 'orders';
OrderPaymentService.BASE_PATH = 'api/orderpayments';
//# sourceMappingURL=OrderPaymentService.js.map